import { useEffect, useRef, useCallback } from "react";
import { Howl } from "howler";

// use-sound (biblioteca usada antes aqui pra esses sons) so troca o
// arquivo numa mudanca de src via um efeito que depende de um import
// dinamico do Howler ja ter terminado - quando o som customizado troca
// do padrao empacotado pro arquivo enviado pelo admin, essa troca as
// vezes perde essa corrida e fica preso no som errado pra sempre, mesmo
// apos F5 completo (confirmado ao vivo: Howler.js mostrava o arquivo
// padrao antigo mesmo com a URL certa ja calculada). Esse hook cria um
// Howl novo direto sempre que o src muda, sem essa corrida.
const usePlaySound = (src, volume = 1) => {
  const howlRef = useRef(null);
  const safeVolume = Number.isFinite(volume) ? Math.min(Math.max(volume, 0), 1) : 1;

  useEffect(() => {
    if (!src) return undefined;
    const howl = new Howl({ src: [src], volume: safeVolume });
    howlRef.current = howl;
    return () => {
      // Nao usa howl.unload() aqui: isso para o audio na hora, mesmo se
      // ainda estiver tocando. Um remount do componente (ex: aceitar um
      // ticket, que reordena a lista) nao deve cortar um som em
      // andamento - o Howl antigo so' fica sem uso e o GC cuida dele.
      if (howlRef.current === howl) howlRef.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [src]);

  useEffect(() => {
    if (howlRef.current) howlRef.current.volume(safeVolume);
  }, [safeVolume]);

  return useCallback(() => {
    if (howlRef.current) howlRef.current.play();
  }, []);
};

export default usePlaySound;
